<template>
  <div class="home-wrapper">
    <!-- 头部 -->
    <el-row class="header">
      <!-- <el-col :span="4" class="chartstitle">检测业务</el-col> -->
      <el-col
        :span="6"
        style="display: flex; justify-content: flex-start; align-items: center"
        ><span class="sideLine"></span>检查业务</el-col
      >
      <el-col :span="10">&nbsp;</el-col>
      <!-- 日期选择器 -->
      <el-col :span="8">
        <el-date-picker
          size="middle"
          v-model="pickerDate"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :editable="false"
          unlink-panels
          :picker-options="pickerOptions"
          @change="handleDateChange"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <!-- <div class="chartstitle"><span class="sideLine"></span>检查业务</div> -->
    <div class="searchBar">
      <el-row>
        <!-- <el-col :span="4" class="chartstitle">检查业务</el-col> -->
        <!-- <el-col :span="2">&nbsp;</el-col> -->
        <!-- 甲方单位 -->
        <el-col :span="7">
          <span>甲方单位：</span>
          <el-select
            size="middle"
            multiple
            clearable
            v-model="firstValue"
            placeholder="请选择甲方单位"
            @change="changePartyName"
          >
            <el-checkbox-group v-model="firstValue">
              <el-option
                v-for="item in firstCompanys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <el-checkbox
                  style="pointer-events: none"
                  :label="item.value"
                ></el-checkbox>
              </el-option>
            </el-checkbox-group>
          </el-select>
        </el-col>
        <el-col :span="7">
          <span>租赁单位：</span>
          <el-select
            size="middle"
            multiple
            clearable
            v-model="unitValue"
            placeholder="请选择租赁单位"
            @change="changeUnit"
          >
            <el-checkbox-group v-model="unitValue">
              <el-option
                v-for="item in unitCompanys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <el-checkbox
                  style="pointer-events: none"
                  :label="item.value"
                ></el-checkbox>
              </el-option>
            </el-checkbox-group>
          </el-select>
        </el-col>
        <!-- 工地  -->
        <el-col :span="6">
          <span>工地：</span>
          <el-select
            size="middle"
            multiple
            clearable
            v-model="projectName"
            placeholder="请选择工地"
            @change="changeProject"
          >
            <el-checkbox-group v-model="projectName">
              <el-option
                v-for="item in projectNames"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <el-checkbox
                  style="pointer-events: none"
                  :label="item.value"
                ></el-checkbox>
              </el-option>
            </el-checkbox-group>
          </el-select>
        </el-col>

        <el-col :span="4">
          <!-- <el-button type="primary" plain @click="search" size="mini"
            >查询</el-button
          >   -->
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="search"
            style="margin: 0 0 0 10px"
          ></el-button>
        </el-col>
        <!-- <el-col :span="0.5">&nbsp;</el-col> -->

        <!-- <el-col :span="2">
        <el-button
          icon="el-icon-search"
          type="primary"
          plain
          @click="search"
          style="height: 40px; margin: 11px 10px 0 10px"
        ></el-button>
      </el-col> -->
      </el-row>
    </div>
    <div class="content">
      <el-row class="date-box" :gutter="20">
        <!-- 方块数据 -->
        <el-col :span="6">
          <div class="date-row data-chart">
            <div
              v-for="(item, index) in cardInfoData"
              :key="index"
              class="data-col"
            >
              <el-card shadow="always" :body-style="{ padding: '0px' }">
                <div class="date-block">
                  <i
                    :class="[item.icon]"
                    :style="{ background: item.color }"
                    class="icon-box iconfont"
                  />
                  <div class="date-cont">
                    <CountTo
                      class="count"
                      :start-val="1000"
                      :autoplay="true"
                      :decimals="item.isDecimals"
                      :end-val="item.count"
                      :duration="2000"
                    />
                    <div class="value" v-if="item.unit != '' || item.rate">
                      <p class="unit" v-if="item.unit != ''">{{ item.unit }}</p>
                      <!-- <p class="rate" v-if="item.rate">{{ item.rate }}</p> -->
                    </div>
                    <p class="title">
                      {{ item.title
                      }}<span v-if="item.remark" style="font-size: 12px">{{
                        item.remark
                      }}</span>
                    </p>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </el-col>
        <!--    叠加柱状图      -->
        <el-col :span="9">
          <el-card
            shadow="always"
            :body-style="{ padding: '0px' }"
            class="data-select"
          >
            <div class="data-chart">
              <StackedColumn
                :title="stackedCommonText"
                :yData="stackedCommonData_y"
                :xData="stackedCommonData_x"
              ></StackedColumn>
            </div>
          </el-card>
        </el-col>
        <!--    叠加柱状图 2     -->
        <el-col :span="9">
          <el-card
            shadow="always"
            :body-style="{ padding: '0px' }"
            class="data-select"
          >
            <el-select
              class="select"
              v-model="QueryAreaRateValue"
              placeholder="请选择"
              @change="QueryAreaRateType"
              filterable
            >
              <el-option
                v-for="item in QueryAreaRateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="data-chart">
              <StackedColumn
                :title="stackedCommonText_s"
                :yData="stackedCommonData_y_s"
                :xData="stackedCommonData_x_s"
              ></StackedColumn>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row class="date-box" :gutter="20">
        <!--    折线图      -->
        <el-col :span="10">
          <el-card
            shadow="always"
            :body-style="{ padding: '0px' }"
            class="data-select"
          >
            <div class="data-chart">
              <!-- <ChartsLine :title="lineTitle" :data="lineData" /> -->
              <DualYAxisChart
                :title="lineTitle"
                :data="lineData"
                leftName="设备数"
                rightName="安全分值"
              />
            </div>
          </el-card>
        </el-col>
        <!--    柱状图      -->
        <el-col :span="14">
          <el-card
            shadow="always"
            :body-style="{ padding: '0px' }"
            class="data-select"
          >
            <el-select
              class="select"
              v-model="commonTypeValue"
              placeholder="请选择维度"
              @change="changeCommonType"
            >
              <el-option
                v-for="item in commonType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="data-chart">
              <!-- <ChartsBar
                :title="commonText"
                :topText="commonToolText"
                :data="commonChartsData"
              /> -->
              <ChartsColumn
                :title="commonText"
                :topText="commonToolText"
                :data="commonChartsData"
              />
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 柱状折线图 -->
      <el-row class="date-box" :gutter="20">
        <el-col :span="10">
          <div class="data-select">
            <el-select
              style="width: 120px"
              v-model="QueryyearValue"
              placeholder="请选择年份"
              clearable
              @change="queryScoreByYearFn"
            >
              <el-option
                v-for="item in yearsList"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <ChartsBarPie
              :title="ScorePercentageTitle"
              :data="ScorePercentageList"
            ></ChartsBarPie>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="data-select">
            <StackedColumnPie
              :title="CountPercentageTitle"
              :data="CountPercentageList"
              :color="CountPercentageColor"
              :legend="ountPercentagelegend"
            ></StackedColumnPie>
          </div>
        </el-col>
      </el-row>
      <el-row class="date-box" :gutter="20">
        <el-col :span="16">
          <div class="data-select">
            <el-select
              v-model="QueryAreaRateValue"
              placeholder="请选择"
              @change="queryInspectProductionCountFn"
            >
              <el-option
                v-for="item in QueryAreaRateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <StackedColumnPie
              :title="ProductionCountTitle"
              :data="ProductionCountList"
              :color="ProductionCountColor"
              :legend="ProductionCountlegend"
            ></StackedColumnPie>
          </div>
        </el-col>
        <!--    饼图      -->
        <el-col :span="8">
          <el-card
            shadow="always"
            :body-style="{ padding: '0px' }"
            class="data-select"
          >
            <el-select
              class="select"
              v-model="pieTypeValue"
              placeholder="请选择维度"
              @change="changePieType"
            >
              <el-option
                v-for="item in pieType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="data-chart">
              <ChartsPie :title="pieText" type="ring" :data="chartsPieData" />
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import ChartsPie from './components/ChartsPie'
// import ChartsBar from './components/ChartsBar'
import ChartsColumn from './components/ChartsColumn'
// import ChartsLine from './components/ChartsLine'
import StackedColumn from './components/StackedColumn'
import ChartsBarPie from './components/ChartsBarPie'
import StackedColumnPie from './components/StackedColumnPie'
import DualYAxisChart from '../detection/components/DualYAxisChart'
// import ChartsBarTable from './components/ChartsBarTable'

import {
  getInpectDeviceCount,
  getDeviceAveScore,
  queryDeviceByType,
  queryScore,
  // queryDeviceByMonth,
  queryScoreByLevel,
  queryScoreByLevel_s,
  queryPartyaNames,
  queryUnit,
  queryProjectName,
  queryScoreByYear,
  queryDeviceCount,
  queryInspectProductionCount,
  queryDeviceAndScoreByMonth
} from '@/api/inspect'
import { querySysData } from '@/api/detection'
import { brequest } from '@/utils/brequest'
export default {
  name: 'Home',
  components: {
    CountTo,
    ChartsPie,
    // ChartsBar,
    ChartsColumn,
    // ChartsLine,
    StackedColumn,
    ChartsBarPie,
    StackedColumnPie,
    DualYAxisChart
    // ChartsBarTable
  },
  data() {
    return {
      roleShow2: true,
      pickerDate: [], //日期 时间戳
      pickerDay: [], //折线图默认时间：前12个月
      timeType: 2, //1年，2月份
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },
      // 甲方单位
      firstCompanys: [],
      firstValue: [], //选中甲方
      // 租赁单位
      unitCompanys: [],
      unitValue: [],
      // 工地
      projectNames: [],
      projectName: [],
      // 方块数据
      cardInfoData: [
        {
          title: '检查总量',
          icon: 'icon-gongzuotongji',
          count: 0,
          isDecimals: 0,
          unit: '',
          color: '#667eea'
        },
        {
          title: '设备平均分',
          icon: 'icon-shebeiOEE',
          count: 0,
          isDecimals: 1,
          remark: '(政府)',
          color: '#19be6b'
        },
        {
          title: '设备平均分',
          icon: 'icon-shebeiOEE',
          count: 0,
          isDecimals: 1,
          remark: '(企业)',
          color: '#ff9a9e'
        }
      ],
      //折线图
      lineData: {},
      lineTitle: '月度设备数和安全分值',
      // 环形图
      // 维度
      pieType: [
        {
          value: '1',
          label: '项目'
        },
        {
          value: '2',
          label: '安装单位'
        },
        {
          value: '3',
          label: '制造单位'
        },
        {
          value: '4',
          label: '设备类型'
        }
      ],
      pieTypeValue: '4', //选中环形图维度
      pieText: '设备数量及占比前10',
      chartsPieData: [], //数据
      //柱状图
      // 维度
      commonType: [
        {
          value: '1',
          label: '项目'
        },
        {
          value: '2',
          label: '安装单位'
        },
        {
          value: '3',
          label: '制造单位'
        },
        {
          value: '4',
          label: '设备类型'
        }
      ],
      commonTypeValue: '4', //选中柱状图维度
      commonText: '得分统计',
      commonToolText: '得分',
      commonChartsData: [],
      //堆叠柱状图
      stackedCommonText: '装置隐患扣分统计',
      stackedCommonData_x: [
        // {
        // name: '扣分',
        // type: 'bar',
        // data: [10, 12, 39, 90, 39]
        // label: {
        //   show: true
        // },
        // emphasis: {
        //   focus: 'series'
        // }
        // }
      ],
      stackedCommonData_y: [],
      //堆叠柱状图
      QueryAreaRateList: [],
      QueryAreaRateValue: '7',
      stackedCommonText_s: '设备隐患扣分统计',
      stackedCommonData_x_s: [],
      stackedCommonData_y_s: [],
      // 季度平均分值和危险设备占比
      ScorePercentageTitle: '季度平均安全分值和危险设备占比',
      ScorePercentageList: [],
      QueryyearValue: new Date().getFullYear(),
      yearsList: [],
      // 一段时间内各分段设备数量及占比
      CountPercentageTitle: '一段时间内各分段设备数量及占比',
      CountPercentageList: [],
      ountPercentagelegend: ['设备数量', '分数段占比'],
      CountPercentageColor: ['#5470C6', 'orange'],
      // 单种设备各品牌检查数量，平均得分图
      ProductionCountlegend: ['检测数量', '平均得分'],
      ProductionCountTitle: '单种设备各品牌检查数量，平均得分图',
      ProductionCountList: [],
      ProductionCountColor: ['#5470c6', '#efa666']
    }
  },
  methods: {
    // 默认时间 默认当前日期之前365天
    defaultTime() {
      if (this.pickerDate.length == 0) {
        // // 默认当前月之前12个月
        // let dataArr = []
        // let data = new Date()
        // let day = data.getDate()
        // data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
        // for (var i = 0; i < 12; i++) {
        //   data.setMonth(data.getMonth() - 1) //每次循环一次 月份值减1
        //   let m = data.getMonth() + 1
        //   m = m < 10 ? '0' + m : m
        //   dataArr.push(data.getFullYear() + '-' + m)
        // }
        // this.pickerDate = [
        //   dataArr[dataArr.length - 1] + '-' + day,
        //   dataArr[0] + '-' + day
        // ]
        // 默认当前日期之前365天
        let sdate = new Date()
        let interval = -365 //间隔天数
        let caret = '-' //日期分隔符
        let strYear = sdate.getFullYear()
        let strDay = sdate.getDate()
        let strMonth = sdate.getMonth() + 1
        let patt1 = /^\d{4}-([0-1]?[0-9])-([0-3]?[0-9])$/ //判断输入的日期是否符合格式正则表达式
        if (!(sdate && typeof sdate == 'string' && patt1.test(sdate))) {
          sdate = new Date() //不满足日期的则使用当前年月日
        }
        interval = isNaN(parseInt(interval)) ? 0 : parseInt(interval) //若没有输入间隔，则使用当前日
        caret = caret && typeof caret == 'string' ? caret : ''
        let gdate = new Date(sdate).getTime() //获取指定年月日
        gdate = gdate + 1000 * 60 * 60 * 24 * interval //加减相差毫秒数
        let speDate = new Date(gdate) //获取指定好毫秒数时间
        let preYear = speDate.getFullYear()
        let preMonth = speDate.getMonth() + 1
        let preDay = speDate.getDate()
        preMonth = preMonth < 10 ? '0' + preMonth : preMonth
        preDay = preDay < 10 ? '0' + preDay : preDay
        let preDate = preYear + caret + preMonth + caret + preDay
        this.pickerDate = [preDate, strYear + '-' + strMonth + '-' + strDay]
      }
    },
    //选择日期事件
    handleDateChange(pickerDate) {
      if (pickerDate != null) {
        let Day_1 = Date.parse(pickerDate[0])
        let Day_2 = Date.parse(pickerDate[1])
        let diffDate = Math.abs(Day_1 - Day_2)
        let totoalDays = Math.floor(diffDate / (1000 * 3600 * 24))
        let month = Math.ceil(totoalDays / 30)
        // console.log(month)
        if (1 <= month && month <= 24) {
          //小于两年,按月
          this.timeType = 2
        } else if (month > 24) {
          //大于两年，按年
          this.timeType = 1
        }
      } else {
        this.pickerDate = []
      }
      //数据请求
      this.getInpectDeviceCount() //检查总数
      this.getDeviceAveScore() //平均得分
      this.queryScoreByLevel() //堆叠柱状图
      this.queryScoreByLevel_s(this.QueryAreaRateValue) //堆叠柱状图2
      this.queryDeviceByType(this.pieTypeValue) //环形图
      this.queryScore(this.commonTypeValue) //柱状图
      this.queryDeviceByMonth() //折线图
      this.queryScoreByYearFn() //柱状折线
      this.queryDeviceCountFn() //柱状折线
      this.queryInspectProductionCountFn() //带表格柱状
    },
    // 数据转换
    numberConversion(value) {
      var param = {}
      var k = 10000,
        sizes = ['', '万', '亿', '万亿'],
        i
      if (value < k) {
        param.value = value
        param.unit = ''
      } else {
        i = Math.floor(Math.log(value) / Math.log(k))

        param.value = (value / Math.pow(k, i)).toFixed(1)
        param.unit = sizes[i]
      }
      return param
    },
    //甲方下拉框
    changePartyName(firstValue) {
      console.log(firstValue)
      this.firstValue = firstValue
      this.unitValue = []
      this.projectName = []
      this.queryUnit(), //租赁单位
        this.queryProjectName() //工地
    },

    //租赁下拉框
    changeUnit(unitValue) {
      // console.log(unitValue)
      this.unitValue = unitValue
      this.projectName = []
      this.queryProjectName() //工地
    },
    //工地下拉框
    changeProject(projectName) {
      this.projectName = projectName
      // this.queryUnit() //租赁单位
    },
    // 获取设备类型
    querySysDataFn() {
      querySysData().then((res) => {
        console.log(res.data, '设备类型舒适的沙发上')
        this.QueryAreaRateList = res.data
        // this.deviceValue = this.deviceTypeList[0].value
      })
    },
    // 点击搜索
    search() {
      // console.log(this.pickerDate)
      if (this.pickerDate == null || this.pickerDate.length == 0) {
        console.log('请选择')
        this.$message({
          message: '请选择日期',
          type: 'warning'
        })
      } else {
        //数据请求
        this.getInpectDeviceCount() //检查总数
        this.getDeviceAveScore() //平均得分
        this.queryScoreByLevel() //堆叠柱状图
        this.queryScoreByLevel_s(this.QueryAreaRateValue) //堆叠柱状图2
        this.queryDeviceByType(this.pieTypeValue) //环形图
        this.queryScore(this.commonTypeValue) //柱状图
        this.queryDeviceByMonth() //折线图
        this.queryScoreByYearFn() //柱状折线
        this.queryDeviceCountFn() //柱状折线
        this.queryInspectProductionCountFn() //带表格柱状
      }
    },
    //甲方单位
    queryPartyaNames() {
      queryPartyaNames().then((res) => {
        console.log(res.data, '甲方单位')
        this.firstCompanys = res.data
      })
    },

    //租赁单位
    queryUnit() {
      var data = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName
      }
      queryUnit(data).then((res) => {
        console.log(res.data, '租赁单位')
        this.unitCompanys = res.data
        // this.queryProjectName() //工地
      })
    },
    //工地
    queryProjectName() {
      var data = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName
      }
      queryProjectName(data).then((res) => {
        console.log(res.data, '工地')
        this.projectNames = res.data
        // this.queryUnit() //租赁单位
      })
    },
    // 堆叠柱状图
    queryScoreByLevel() {
      var data = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }

      queryScoreByLevel(data).then((res) => {
        console.log(res.data, '堆叠柱状图')
        if (res.data) {
          this.stackedCommonData_x = res.data.stackedCommonData_x || []
          this.stackedCommonData_y = res.data.stackedCommonData_y || []
        }
      })
    },
    //设置日期列表
    initYears() {
      var myDate = new Date()
      var year = myDate.getFullYear() //获取当前年
      this.initSelectYear(year)
    },
    initSelectYear(year) {
      this.yearsList = []
      for (let i = 0; i < 30; i++) {
        this.yearsList.push({ value: year - i, label: year - i + '年' })
      }
    },
    // 堆叠柱状图2
    queryScoreByLevel_s(deviceType) {
      console.log('quq省解放军')
      var data = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        deviceType
      }
      queryScoreByLevel_s(data).then((res) => {
        console.log(res.data, '堆叠柱状图2')
        if (res.data) {
          this.stackedCommonData_x_s = res.data.stackedCommonData_x || []
          this.stackedCommonData_y_s = res.data.stackedCommonData_y || []
        }
      })
    },
    //折线图
    queryDeviceByMonth() {
      if (this.pickerDate.length == 0) {
        // 默认当前月之前12个月
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
        for (var i = 0; i < 12; i++) {
          data.setMonth(data.getMonth() - 1) //每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + m)
        }
        this.pickerDay = [
          dataArr[dataArr.length - 1] + '-' + day,
          dataArr[0] + '-' + day
        ]
      }
      let obj = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        startDt: this.pickerDate[0] || this.pickerDay[0],
        endDt: this.pickerDate[1] || this.pickerDay[1],
        timeType: this.timeType //1:年，2：月
      }
      // console.log(obj)
      queryDeviceAndScoreByMonth(obj).then((res) => {
        if (res.data && res.data.length > 0) {
          let dataObj = {}

          let datas = res.data
          dataObj.xData = datas.map((i) => i.month)
          dataObj.leftData = datas.map((i) => i.totalCount)
          dataObj.rightData = datas.map((i) => i.safetyScore)

          this.lineData = dataObj
        } else {
          this.lineData = {}
        }
      })
    },
    //堆叠图下拉
    QueryAreaRateType() {
      this.queryScoreByLevel_s(this.QueryAreaRateValue)
    },
    //环形图下拉选择
    changePieType(pieTypeValue) {
      console.log(pieTypeValue)
      // 设备数量
      this.queryDeviceByType(pieTypeValue)
    },
    //柱状图下拉选择
    changeCommonType(commonTypeValue) {
      console.log(commonTypeValue)
      // 得分统计
      this.queryScore(commonTypeValue)
    },
    //设备总数
    getInpectDeviceCount() {
      var data = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      getInpectDeviceCount(data).then((res) => {
        console.log(res, '总数')
        if (res.data) {
          this.cardInfoData[0].count = Number(res.data.count)

          // 检测设备总台数
          // this.cardInfoData[0].count = Number(res.data[0].count)
          // let zerocount = this.numberConversion(res.data.count)
          // this.cardInfoData[0].count = Number(zerocount.value)
          // if (zerocount.unit) {
          //   this.cardInfoData[0].isDecimals = 1
          //   this.cardInfoData[0].unit = zerocount.unit
          // }
        }
      })
    },
    // async getInpectDeviceCount() {
    //   var count = {
    //     partyaName: this.firstValue,
    //     startDt: this.pickerDate[0] || '',
    //     endDt: this.pickerDate[1] || ''
    //   }
    //   console.log(count)
    //   const res = await getInpectDeviceCount(count)
    //   console.log(res)
    // },
    // 设备平均分
    getDeviceAveScore() {
      var data = {
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      // console.log(data)
      getDeviceAveScore(data).then((res) => {
        console.log(res, '平均分')
        res.data.forEach((element, i) => {
          this.cardInfoData[i + 1].count = Number(res.data[i].aveScore)
        })
        console.log(this.cardInfoData, '==================')
      })
    },
    // 根据类型统计设备数量（环形图）
    queryDeviceByType(dimension) {
      var data = {
        dimension, //设备类型
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      // console.log(data)
      queryDeviceByType(data).then((res) => {
        if (res.data) {
          let ChartsData = res.data.slice(0, 10)

          this.chartsPieData = ChartsData.map((r) => {
            return { name: r.name, value: parseInt(r.value) }
          })
          console.log(this.chartsPieData, '环形图')
        }
      })
    },
    // 多个维度统计得分(柱状图)
    queryScore(dimension) {
      var data = {
        dimension, //设备类型
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName,
        order: 'desc', //降序
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      // console.log(data)
      queryScore(data).then((res) => {
        console.log(res.data, '柱状图')
        //数组排序方法
        // function compare(i, desc) {
        //   return function (a, b) {
        //     var value1 = a[i]
        //     var value2 = b[i]
        //     if (desc == true) {
        //       //升序
        //       return value1 - value2
        //     } else {
        //       //降序
        //       return value2 - value1
        //     }
        //   }
        // }
        // console.log(数组.sort(compare('num', true)))
        if (res.data) {
          this.commonChartsData = res.data.slice(0, 50)
        }
      })
    },
    // 单种设备各责任单位平均得分，检查数量，危险设备数（塔机，电梯）
    queryScoreByYearFn(year) {
      console.log(year, this.QueryyearValue)
      let queryScoreByYearData = {
        year: year || this.QueryyearValue,
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName
      }
      queryScoreByYear(queryScoreByYearData).then((res) => {
        this.ScorePercentageList = res.data
      })
    },
    // 降序排
    sortBy(props) {
      return function (a, b) {
        return b[props] - a[props]
      }
    },

    // 一段时间内各分段设备数量及占比
    queryDeviceCountFn() {
      let queryDeviceCountData = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName
      }
      queryDeviceCount(queryDeviceCountData).then((res) => {
        console.log(res.data)
        this.CountPercentageList = res.data
      })
    },
    // 单种设备各品牌检查数量，平均得分图（塔机，施工升降机）
    queryInspectProductionCountFn(deviceType) {
      let queryInspectProductionCountData = {
        deviceType: deviceType || '7', //默认塔式起重机
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        partyaName: this.firstValue,
        unit: this.unitValue,
        projectName: this.projectName
      }
      queryInspectProductionCount(queryInspectProductionCountData).then(
        (res) => {
          console.log(res.data)
          let CountList = res.data
          this.ProductionCountList = CountList.map((el) => {
            return {
              time: el.unitProduction,
              pcl: el.aveScore,
              count: el.count
            }
          })
          this.ProductionCountList.sort(this.sortBy('count'))
        }
      )
    },
    // 仪表盘模块展示权限
    async queryDashboardModule() {
      let ret = await brequest({
        url: '/user/queryDashboardModule',
        method: 'post'
      })
      //权限id判断是否展示子菜单
      console.log(ret, '权限', ret.indexOf('2'))
      if (ret.indexOf('2') == -1) {
        //不存在
        this.commonType.forEach((value, index, array) => {
          if (value.value == '2') {
            //柱状图删除安装单位所在对象
            array.splice(index, 1)
          }
        })
        this.pieType.forEach((value, index, array) => {
          if (value.label == '安装单位') {
            //环形图删除安装单位所在对象
            array.splice(index, 1)
          }
        })
      }
    }
    // queryDashboardModule() {
    //   queryDashboardModule().then((res) => {
    //     console.log(res)
    //   })
    // }
  },
  beforeCreate() {},
  created() {
    // this.defaultTime()
    this.initYears()
    this.queryDashboardModule()
    this.querySysDataFn() //设备类型
    this.queryPartyaNames() //甲方单位
    this.queryUnit(), //租赁单位
      this.queryProjectName(), //工地
      this.getInpectDeviceCount() //检查总数
    this.getDeviceAveScore() //平均得分
    this.queryScoreByLevel() //堆叠柱状图
    this.queryScoreByLevel_s(this.QueryAreaRateValue) //堆叠柱状图2
    this.queryDeviceByType(this.pieTypeValue) //环形图
    this.queryScore(this.commonTypeValue) //柱状图
    this.queryDeviceByMonth() //折线图
    this.queryScoreByYearFn() //柱状折线
    this.queryDeviceCountFn() //柱状折线
    this.queryInspectProductionCountFn() //带表格柱状
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.home-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #f0f2f5;
  min-height: 100%;

  .chartstitle {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    color: #4a4848;
    width: 100%;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    .sideLine {
      width: 8px;
      height: 36px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 4px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  .header {
    justify-content: space-between;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    color: #4a4848;
    width: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 0 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    .sideLine {
      width: 8px;
      height: 36px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 4px;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  .searchBar {
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  .date-row {
    .data-col {
      margin-bottom: 13px;
      margin-right: 20px;
      .el-card {
        border-radius: 12px;
        border: none;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }
      }
      .date-block {
        display: flex;
        align-items: center;
        height: 90px;

        .icon-box {
          font-size: 40px;
          width: 120px;
          height: 120px;
          text-align: center;
          line-height: 120px;
          color: #fff;
        }
        .date-cont {
          flex: 1;
          text-align: center;
          color: #515a6e;
          .count {
            line-height: 60px;
            font-size: 35px;
            font-weight: 600;
          }
          .title {
            font-size: 16px;
            color: #666;
          }
        }
      }
    }
  }

  .date-box {
    margin-bottom: 20px;
  }

  .data-desc {
    width: 100%;
    height: 360px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  .data-chart {
    width: 100%;
    height: 400px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  .data-select {
    width: 100%;
    height: 400px;
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    .el-select {
      position: absolute;
      z-index: 10;
      right: 10px;
      top: 10px;
      width: 30%;
    }
  }

  .data-lang-box {
    padding: 10px 25px;
    box-sizing: border-box;
    .data-lang-title {
      line-height: 32px;
      font-size: 16px;
      text-align: center;
      margin-bottom: 10px;
    }
    .data-lang-item {
      height: 48px;
      line-height: 20px;
    }
  }

  .select {
    position: absolute;
    z-index: 10;
    right: 10px;
    width: 30%;
  }

  .el-card {
    position: relative;
  }

  ::v-deep .el-select__tags {
    flex-wrap: nowrap;
    overflow: auto;
  }

  ::v-deep .el-select__tags-text {
    max-width: 90px;
  }

  ::v-deep .el-select__tags::-webkit-scrollbar {
    height: 4px !important;
  }
}
</style>
